import React, { useState, useEffect, useRef } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { IsNull, localStoreObjects } from "../utilities/util";
import { useAuth } from "./features/AuthContext";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const [_logout, setLogout] = useState(false);
  const { isAuthenticated, login, logout } = useAuth();

  const [selectedHost, setSelectedHost] = useState(() => {
    return localStorage.getItem("apiHost") || "http://localhost:5000/";
  });

  // const apiHosts = [
  //   { label: "Production", value: "https://prod.smartmaheshwari.com/api/" },
  //   { label: "Staging", value: "https://api.smartmaheshwari.com/" },
  //   { label: "Localhost", value: "http://localhost:5000/" }
  // ];

  const handleHostChange = (value) => {
    setSelectedHost(value);
    localStorage.setItem("apiHost", value);
  };

  useEffect(() => {
    const _logged = localStorage.getItem(localStoreObjects.userId);
    setLogout(IsNull(_logged));

    const handleOutsideClick = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }

    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [isOpen]);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  // const navLinks = [
  //   { to: "/", label: "Home" },
  //   { to: "/Privacy", label: "Privacy" },
  //   {
  //     to: "#",
  //     label: "Requests",
  //     submenu: [
  //       { to: "/TardinessData", label: "Tardiness Notices" },
  //       { to: "/ScheduledRequests", label: "Scheduled Request" },
  //     ],
  //   },
  // ];

  // if (!isAuthenticated) {
  //   navLinks.push({ to: "/login", label: "Login" });
  // } else {
  //   navLinks.push({
  //     to: "#",
  //     label: "Logout",
  //     onClick: () => {
  //       localStorage.removeItem(localStoreObjects.userId);
  //       localStorage.removeItem(localStoreObjects.bgmiProfile);
  //       localStorage.removeItem(localStoreObjects.profilePic);
  //       localStorage.removeItem(localStoreObjects.step);
  //       logout();
  //     },
  //   });
  // }

  return (
    <nav className="bg-transparent shadow-sm border-b z-50">
<div className="max-w-7xl mx-auto flex justify-center items-center px-4 py-3">
  <Link to="/" className="block">
    {/* <img
      src="logo.png"
      alt="Logo"
      className="w-28 h-12 object-contain mx-auto"
    /> */}
    <h2 className="text-red-500 font-bold text-2xl underline">DELIGHT LONG ISLAND LLC</h2>
  </Link>

        {/* <button onClick={toggleMenu} className="md:hidden text-gray-700">
          {isOpen ? <X size={28} /> : <Menu size={28} />}
        </button> */}

        <div className="hidden md:flex items-center space-x-6">
          {/* {navLinks.map((nav) => (
            nav.submenu ? (
              <div className="relative group" key={nav.label}>
                <span className="cursor-pointer text-gray-700 hover:text-blue-600">{nav.label}</span>
                <ul className="absolute hidden group-hover:block bg-white shadow-md mt-2 rounded-md w-48">
                  {nav.submenu.map((item) => (
                    <li key={item.label}>
                      <NavLink to={item.to} className="block px-4 py-2 text-sm text-gray-600 hover:bg-gray-100">
                        {item.label}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
            ) : (
              <NavLink
                key={nav.label}
                to={nav.to}
                onClick={nav.onClick}
                className={({ isActive }) =>
                  `text-sm font-medium hover:text-blue-600 ${
                    isActive ? "text-blue-600 border-b-2 border-blue-600 pb-1" : "text-gray-700"
                  }`
                }
              >
                {nav.label}
              </NavLink>
            )
          ))} */}

          {/* <APIDropdown
            selectedHost={selectedHost}
            setSelectedHost={handleHostChange}
            apiHosts={apiHosts}
          /> */}
        </div>
      </div>

      {/* {isOpen && (
        <div ref={menuRef} className="md:hidden px-4 pb-4 space-y-2 text-sm">
          {navLinks.map((nav) => (
            nav.submenu ? (
              <div key={nav.label} className="text-left">
                <span className="font-medium text-gray-600">{nav.label}</span>
                <ul className="ml-4 space-y-1 mt-1">
                  {nav.submenu.map((item) => (
                    <li key={item.label}>
                      <NavLink to={item.to} className="block text-gray-700 hover:text-blue-500">
                        {item.label}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
            ) : (
              <NavLink
                key={nav.label}
                to={nav.to}
                onClick={nav.onClick}
                className="block text-gray-700 hover:text-blue-500"
              >
                {nav.label}
              </NavLink>
            )
          ))}
        </div>
      )} */}
    </nav>
  );
};

export default Navbar;
